var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ajaxSend } from '../../../api/api';
export const basePath = '/v2/statistics';
export const baseQueuePath = `${basePath}/dashboard/queue`;
export const baseAgentQueuePath = `${basePath}/dashboard/agent/queue`;
/**
 * Gets search params from an API path.
 *
 * @param path The path.
 */
export function apiPathToSearchParams(path) {
    const searchParams = path.split('?').pop();
    return Array.from(new URLSearchParams(searchParams).entries()).reduce((acc, [key, value]) => (Object.assign(Object.assign({}, acc), { [key]: value })), {});
}
/**
 * Gets dashboard queues.
 *
 * @param params The dashboard queue query params.
 */
export function getAllQueues(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const path = `${baseQueuePath}?${new URLSearchParams(params)}`;
        const data = yield ajaxSend({ path });
        data.meta.current_page = path;
        return data;
    });
}
/**
 * Gets dashboard agent queues.
 *
 * @param params The dashboard queue query params.
 */
export function getAgentQueues(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const path = `${baseAgentQueuePath}?${new URLSearchParams(params)}`;
        const data = yield ajaxSend({ path });
        data.meta.current_page = path;
        return data;
    });
}
/**
 * Gets queues by their id's.
 *
 * @param queueIds The string array of queue id's.
 * @param sortBy The sort_by string.
 */
export function getQueuesById(params) {
    return ajaxSend({
        path: baseQueuePath,
        params,
    });
}
/** @deprecated See TEAMS-4114 */
const v1BasePath = '/v1/statistics';
/**
 * Gets all available queues from the v1 dashboard queue endpoint.
 *
 * @deprecated See TEAMS-4114
 */
export function getAllQueuesV1() {
    return ajaxSend({
        path: `${v1BasePath}/dashboard/queue`,
    });
}
/**
 * Gets all available agent queues from the v1 dashboard agent queue endpoint.
 *
 * @deprecated See TEAMS-4114
 */
export function getAgentQueuesV1() {
    return ajaxSend({
        path: `${v1BasePath}/dashboard/agent/queue`,
    });
}
